import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetUser, UpdateUser } from "../../../Redux/Slices/User";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import { FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../asset/new/css/employer-modern.css";

const EditProfile = () => {
  const navigate = useNavigate();
  let id = localStorage.getItem("id");

  const { userData } = useSelector((state) => state?.User);
  const [editData, setEditData] = useState(userData);
  const dispatch = useDispatch();

  let name, value;
  const postUserData = (e) => {
    name = e.target.name;
    value = e.target.value;

    setEditData((prevData) => ({ ...prevData, [name]: value }));
  };
  // Submit Button
  const SubmitInfo = async (e) => {
    e.preventDefault();
    let data = {
      name: editData?.name || userData?.name,
      email: userData?.email,
      mobile: editData?.mobile || userData?.mobile,
      experience: {
        designation:
          editData?.designation || userData?.experience[0]?.designation,
        company_name:
          editData?.companyName || userData?.experience[0]?.company_name,
        company_web:
          editData?.companyWebsite || userData?.experience[0]?.company_web,
      },
      gst: editData?.gst || userData?.gst,
    };
    await UpdateUser(id, data, "application/json");
    dispatch(GetUser(id));
    setEditData("");
    navigate("/employer/profile");
  };

  useEffect(() => {
    dispatch(GetUser(id));
    if (userData) {
      setEditData(userData);
    }
    document.title = "Edit Profile | CAJobPortal";
  }, [dispatch]);

  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'Profile', 'Edit Profile']}>
        <div className="employer-page-header">
          <h1 className="employer-page-title">Edit Profile</h1>
        </div>

        <div className="employer-card">
          <div className="employer-card-body">
            <form onSubmit={SubmitInfo}>
              <div className="employer-form-row">
                <div className="employer-form-group">
                  <label className="employer-form-label required">Name</label>
                  <input
                    type="text"
                    className="employer-form-input"
                    name="name"
                    placeholder="Enter your name"
                    value={userData?.name}
                    onChange={(e) => postUserData(e)}
                    required
                  />
                </div>
                <div className="employer-form-group">
                  <label className="employer-form-label">Designation</label>
                  <input
                    type="text"
                    className="employer-form-input"
                    placeholder="Enter your designation"
                    name="designation"
                    onChange={(e) => postUserData(e)}
                    value={userData?.experience[0]?.designation}
                  />
                </div>
              </div>

              <div className="employer-form-row">
                <div className="employer-form-group">
                  <label className="employer-form-label">Company Name</label>
                  <input
                    type="text"
                    className="employer-form-input"
                    name="companyName"
                    value={userData?.experience[0]?.company_name}
                    onChange={(e) => postUserData(e)}
                    placeholder="Enter company name"
                  />
                </div>
                <div className="employer-form-group">
                  <label className="employer-form-label">Company Website</label>
                  <input
                    type="text"
                    className="employer-form-input"
                    value={userData?.experience[0]?.company_web}
                    placeholder="Enter company website"
                    name="companyWebsite"
                    onChange={(e) => postUserData(e)}
                  />
                </div>
              </div>

              <div className="employer-form-row">
                <div className="employer-form-group">
                  <label className="employer-form-label">Mobile Number</label>
                  <input
                    type="text"
                    className="employer-form-input"
                    name="mobile"
                    placeholder="Enter mobile number"
                    value={userData?.mobile}
                    onChange={(e) => postUserData(e)}
                    disabled={userData?.mobile ? true : false}
                  />
                </div>
                <div className="employer-form-group">
                  <label className="employer-form-label">Email</label>
                  <input
                    type="text"
                    className="employer-form-input"
                    name="email"
                    placeholder="Email address"
                    value={userData?.email}
                    disabled
                  />
                  <div className="employer-form-help">Email cannot be changed</div>
                </div>
              </div>

              <div className="employer-form-group">
                <label className="employer-form-label">GST Number</label>
                <input
                  type="text"
                  className="employer-form-input"
                  name="gst"
                  placeholder="Enter GST number"
                  value={userData?.gst}
                  onChange={(e) => postUserData(e)}
                />
              </div>

              <div className="employer-flex employer-gap-2" style={{ justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                <button
                  type="button"
                  onClick={() => navigate("/employer/profile")}
                  className="employer-btn employer-btn-secondary"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="employer-btn employer-btn-primary"
                >
                  <FaSave /> Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </EmployerLayout>
    </div>
  );
};

export default EditProfile;
